const REQUIRED_PARAM_MAP = {
  fechadenacimiento: 1,
  nombre: 3,
  apellido: 6,
  numerodedocumento: 11,
  pais: 15,
  nacionalidad: 16,
  titulardelareserva: 21,
};

export const parsePassengers = passengers => {
  const passengerValues = [];
  const passengerDetails = [];

  passengers.forEach((passenger, index) => {
    const isHolder = index === 0;

    // 1️⃣ passengers (passangers en backend)
    passengerValues.push({
      id_passanger_type: passenger.passengerType,
      sequence_passanger: passenger.passengerSequence,
      sequence: passenger.room,
    });

    // 2️⃣ passangerDetails
    Object.entries(REQUIRED_PARAM_MAP).forEach(([field, id_required_param]) => {
      const value =
        field === 'titulardelareserva' ? isHolder : passenger[field];

      if (value !== undefined && value !== '') {
        passengerDetails.push({
          id_required_param,
          sequence_passanger: passenger.passengerSequence,
          description: value,
        });
      }
    });
  });

  return { passengerValues, passengerDetails };
};
